import {
    TypographyWeights 
} from '../../../../../figmaTheme';

import {
    AGE_RANGES, GENDER_CHOICES, PRONOUN_CHOICES 
} from '../../../config/types';
import AboutYouSection from '../../../screens/animations/aboutYouSection';
import DrinkRecommendations from '../../../screens/animations/drinkRecommendations';
import QuoteScreen from '../../../screens/animations/quote';
import SectionIntro from '../../../screens/animations/sectionIntro';
import Testimonial from '../../../screens/animations/testimonial';
import EmailInputScreen from '../../../screens/emailInput';
import MultipleChoiceScreen from '../../../screens/multipleChoice';

export const ABOUT_YOU_SCREENS = [
    {
        key: 'about you section',
        trackingName: 'about you section',
        screenName: 'about you section',
        component: <AboutYouSection />
    },
    {
        key: 'about you section intro',
        screenName: 'about you section intro',
        component: (
            <SectionIntro
                sectionKey={'aboutYou'}
                subtitle={'Now, tell us a little more about yourself to help us personalize and refine your custom plan.'}
            />
        )
    },
    {
        key: 'email entry',
        trackingName: 'email entry',
        screenName: 'email entry',
        component: (
            <EmailInputScreen
                position={1}
                sectionKey={'aboutYou'}
                backJump={2}
            />
        )
    },
    {
        key: 'gender',
        trackingName: 'gender',
        screenName: 'gender',
        component: (
            <MultipleChoiceScreen
                position={2}
                sectionKey={'aboutYou'}
                answerKey={'gender'}
                title={'What was your assigned sex at birth?'}
                subtitle={'We only ask this because guidelines for healthy drinking levels vary based on biological differences in processing alcohol.'}
                choices={GENDER_CHOICES}
            />
        )
    },
    {
        key: 'pronouns',
        trackingName: 'pronouns',
        screenName: 'pronouns',
        component: (
            <MultipleChoiceScreen
                position={3}
                sectionKey={'aboutYou'}
                answerKey={'pronouns'}
                title={'Now for gender identity. What are your preferred pronouns?'}
                subtitle={'Your coaching team will use these any time we interact. At Sunnyside, we celebrate your authentic you.'}
                choices={PRONOUN_CHOICES}
            />
        )
    },
    {
        key: 'age range',
        trackingName: 'age_range',
        screenName: 'age range',
        component: (
            <MultipleChoiceScreen
                position={4}
                sectionKey={'aboutYou'}
                answerKey={'age_range'}
                title={'What is your age range?'}
                subtitle={'We\'ll use this information to cater your experience to your current life stage.'}
                choices={AGE_RANGES}
            />
        )
    },
    {
        key: 'recommended drinks',
        trackingName: 'recommended drinks',
        screenName: 'recommended drinks',
        component: (
            <DrinkRecommendations
                position={5}
            />
        )
    },
    {
        key: 'testimonial',
        trackingName: 'testimonial',
        screenName: 'testimonial',
        component: (
            <Testimonial
                position={6}
            />
        )
    },
    {
        key: 'about you quote',
        trackingName: 'about you quote',
        screenName: 'about you quote',
        component: (
            <QuoteScreen
                sectionKey={'aboutYou'}
                title={'You\'re on your way to a healthier you.'}
                subtitle={'Almost there! We have everything we need to customize your Sunnyside journey, and get you to your goals.'}
                quote={`<span style="font-size:48px;line-height:60px;font-weight:${TypographyWeights.SEMI_BOLD};">97%</span><br />of members report drinking less since joining Sunnyside.`}
            />
        )
    }
];

export const ABOUT_YOU_SCREENS_V2 = [
    {
        key: 'about you section',
        trackingName: 'about you section',
        screenName: 'about you section',
        component: <AboutYouSection />
    },
    {
        key: 'about you section intro',
        screenName: 'about you section intro',
        component: (
            <SectionIntro
                sectionKey={'aboutYou'}
                subtitle={'Now, tell us a little more about yourself to help us personalize and refine your custom plan.'}
            />
        )
    },
    {
        key: 'gender',
        trackingName: 'gender',
        screenName: 'gender',
        component: (
            <MultipleChoiceScreen
                position={1}
                sectionKey={'aboutYou'}
                answerKey={'gender'}
                title={'What was your assigned sex at birth?'}
                subtitle={'We only ask this because guidelines for healthy drinking levels vary based on biological differences in processing alcohol.'}
                choices={GENDER_CHOICES}
                backJump={2}
            />
        )
    },
    {
        key: 'pronouns',
        trackingName: 'pronouns',
        screenName: 'pronouns',
        component: (
            <MultipleChoiceScreen
                position={2}
                sectionKey={'aboutYou'}
                answerKey={'pronouns'}
                title={'Now for gender identity. What are your preferred pronouns?'}
                subtitle={'Your coaching team will use these any time we interact. At Sunnyside, we celebrate your authentic you.'}
                choices={PRONOUN_CHOICES}
            />
        )
    },
    {
        key: 'age range',
        trackingName: 'age_range',
        screenName: 'age range',
        component: (
            <MultipleChoiceScreen
                position={3}
                sectionKey={'aboutYou'}
                answerKey={'age_range'}
                title={'What is your age range?'}
                subtitle={'We\'ll use this information to cater your experience to your current life stage.'}
                choices={AGE_RANGES}
            />
        )
    },
    {
        key: 'recommended drinks',
        trackingName: 'recommended drinks',
        screenName: 'recommended drinks',
        component: (
            <DrinkRecommendations
                position={4}
            />
        )
    },
    {
        key: 'testimonial',
        trackingName: 'testimonial',
        screenName: 'testimonial',
        component: (
            <Testimonial
                position={5}
            />
        )
    },
    {
        key: 'about you quote',
        trackingName: 'about you quote',
        screenName: 'about you quote',
        component: (
            <QuoteScreen
                sectionKey={'aboutYou'}
                title={'You\'re on your way to a healthier you.'}
                subtitle={'Almost there! We have everything we need to customize your Sunnyside journey, and get you to your goals.'}
                quote={`<span style="font-size:48px;line-height:60px;font-weight:${TypographyWeights.SEMI_BOLD};">97%</span><br />of members report drinking less since joining Sunnyside.`}
            />
        )
    }
];
